<script lang="ts" setup>
/* eslint-disable vue/no-v-html */
export interface PagebuilderPlaintextProps {
    data: {
        text: string
    }
}

const props = defineProps<PagebuilderPlaintextProps>()
</script>
<template>
  <div class="row justify-content-center">
    <div
      class="col-md-10 col-lg-10 order-1 order-md-2"
      data-cy="article_detail_content"
    >
      <Typo type="ext">
        <div
          class="magazine-detail-content"
          v-html="$formatTableHtml(props.data.text)"
        />
      </Typo>
    </div>
  </div>
</template>
